module.exports = "/_next/static/images/baec7fc78eb032385fa47378d0d5f2bf-for-who-md.jpg.webp";